export default "__VITE_ASSET__BH$0QrCK__"